import debounce from 'lodash.debounce';
export const defaultOptions = {
    searchDebounce: 500,
    searchThreshold: 4,
};
/**
 * MapService serves as a utility interface on top of `MapModule`.
 */
class MapService {
    constructor(mapModule, options) {
        this.mapModule = mapModule;
        this.options = Object.assign(Object.assign({}, defaultOptions), options);
        this.privateDebouncedSearch = debounce(this.privateSearch, this.options.searchDebounce);
    }
    privateSearch(searchText, callback) {
        var _a;
        const formattedText = searchText.trim();
        if (!formattedText
            || (((_a = this.options) === null || _a === void 0 ? void 0 : _a.searchThreshold)
                ? formattedText.length < this.options.searchThreshold
                : false)) {
            callback([]);
            return;
        }
        this.mapModule
            .search(searchText)
            .then((searchResult) => {
            callback(this.mapModule.formatSearchResult(searchResult));
        })
            .catch((error) => {
            console.error(`MapService: ${error}`);
            callback([]);
        });
    }
    /**
     * Gets a human-readable label for the suggestion location.
     */
    getSuggestionLabel(suggestion) {
        return this.mapModule.getSuggestionLabel(suggestion);
    }
    /**
     * Debounced search functionality that returns a list of suggestions.
     */
    search(searchText) {
        return (new Promise((resolve) => {
            this.privateDebouncedSearch(searchText, resolve);
        }));
    }
}
export { MapService };
